import { useStoreBoot } from '@/api/useStoreBoot';
import { BootData } from '@/lib/types';

import { AuthHelpLink } from './AuthHelpLink';

export const FindYourUsername = (): React.ReactElement | null => {
  const { getBoot } = useStoreBoot();
  const bootData = getBoot.data as BootData;

  const { usernamePasswordOn, usernamePassword } =
    bootData?.integration?.playersAuthentication ?? {};

  return (
    <AuthHelpLink
      on={usernamePasswordOn}
      text={usernamePassword?.helpLink?.title}
      url={usernamePassword?.helpLink?.url}
      testId="PortalLoginModal-FindYourUsername"
    />
  );
};
